<template>
  <div class="wrapped-with-fsghpnsidq">
    <CContainer fluid class="px-0">
      <CCard>
        <CCardHeader>
          <CRow class="my-3 d-flex align-items-center">
            <CCol
              class="d-flex flex-column justify-content-between align-self-start"
              :md="6"
            >
              <CCardTitle class="mb-0">{{ props.title }}</CCardTitle>
              <CCardText class="fw-light">{{ props.subtitle }}</CCardText>
            </CCol>
            <CCol :md="2" class="d-flex justify-content-end">
              <CButton
                v-if="props.showAddButton"
                color="success"
                style="height: 32px"
                @click="addButtonClickHandler"
              >
                <i class="fa fa-plus" />
                {{ props.addText }}
              </CButton>
            </CCol>
            <slot name="filters" :data="inputSearch">
              <CCol :sm="props.showMergeOptions ? '3' : '4'">
                <CInputGroup class="float-right with-button">
                  <CInputGroupText class="btn btn-secondary">
                    <i class="fa fa-search" />
                  </CInputGroupText>
                  <CFormInput
                    id="global-filter"
                    v-model="inputSearch"
                    type="text"
                    placeholder="Filter"
                  />
                </CInputGroup>
              </CCol>
            </slot>
            <CCol v-if="props.showMergeOptions" :sm="1">
              <MergerModal
                :title="props.title"
                :id-column="props.mergeOptions.idColumn"
                :set-row="setRow"
                :show="mergeModal"
                :schema="props.mergeOptions.schema"
                :data="props.data"
                :data-processor="props.mergeOptions.dataProcessor"
                :value-processor="props.mergeOptions.valueProcessor"
                :custom-validation="props.mergeOptions.customValidation"
                @close="mergeModal = false"
                @open="mergeModal = true"
                @done="d => emit('merge-done', d)"
              >
                <template #mergeTitle>
                  {{ $t("merge-component-title") }}
                </template>
              </MergerModal>
            </CCol>
          </CRow>

          <slot name="table-header" />
        </CCardHeader>
        <CCardBody class="v-tables-component">
          <p v-if="isLoading" class="loading">{{ $t("loading") }}</p>

          <v-client-table
            v-else
            ref="tableElement"
            :key="key"
            :data="computedData"
            :columns="props.columns"
            :options="options"
            @row-click="rowClickHandler"
            @loaded="handleTableLoaded"
          >
            <template #name="{ row }">
              <b>{{ row.name }}</b>
              <div class="text-muted small" style="cursor: pointer">
                <i class="fa fa-copy" />
                {{ row.id }}
              </div>
            </template>

            <template #reference="{ row }">
              <b>{{ row.reference }}</b>
              <div class="text-muted small" style="cursor: pointer">
                <i class="fa fa-copy" />
                {{ row.id }}
              </div>
            </template>

            <template #customer="{ row }">
              <b v-if="row.customer">{{ row.customer.name }}</b>
              <b v-else>/</b>
              <div
                v-if="row.customer"
                class="text-muted small"
                style="cursor: pointer"
              >
                <i class="fa fa-copy" />
                {{ row.customer.id }}
              </div>
            </template>

            <template #order_id="{ row }">
              <button type="button" class="text-left btn btn-link">
                {{ row.id }}
              </button>
            </template>

            <template #user="{ row }">
              <b>{{ row.user }}</b>
              <div class="text-muted small" style="cursor: pointer">
                <i class="fa fa-copy" />
                {{ row.user }}
              </div>
            </template>

            <template #extension="{ row }">
              <CBadge v-if="row.extension == 'dxf'" color="warning">.dxf</CBadge>
              <CBadge v-if="row.extension == 'step'" color="primary">.step</CBadge>
              <CBadge v-if="row.extension == 'stp'" color="primary">.stp</CBadge>
              <CBadge v-if="row.extension == 'pdf'" color="danger">.pdf</CBadge>
            </template>

            <!-- This is duplicate but different please check -->
            <!-- <template #delivery_date="data">
              <span>{{ data.row.delivery_date }}</span><br>
              <div class="text-muted small">{{ data.row.delivery_date }}</div>
            </template> -->

            <template #total_amount="{ row }">
              <div v-if="row.total_amount != null">
                {{ Math.round(row.total_amount * 100) / 100 }}
              </div>
              <div v-if="row.total_amount == null">/</div>
            </template>

            <!-- <template #process="data">
              <CBadge color="secondary">{{ data.row.process }}</CBadge
              ><br />
            </template> -->

            <template #username="{ row }">
              <b>{{ row.username }}</b>
              <div
                class="text-muted small"
                style="cursor: pointer"
                @click.stop="copyTextToClipboard((row.id || '').toString(), `${row.id} ${$t('copied_to_clipboard')}`)"
              >
                <i class="fa fa-copy" />
                {{ row.id }}
              </div>
            </template>

            <template #first_name="{ row }">
              {{ row.last_name }}
              <br />
              {{ row.first_name }}
            </template>

            <template #active="{ row }">
              <label v-if="row.is_active" class="switch switch-pill switch-success">
                <input type="checkbox" class="switch-input" checked disabled />
                <span class="switch-slider" />
              </label>
              <label v-if="!row.is_active" class="switch switch-pill switch-success">
                <input type="checkbox" class="switch-input" disabled />
                <span class="switch-slider" />
              </label>
            </template>

            <template #material="{ row }">
              {{ row?.material?.name }}
            </template>

            <template #certificates="{ row }">
              <span v-for="(certificate, i) in row.certificates" :key="i">
                <CBadge v-if="certificate == 'TYPE_22'" color="secondary">2.2</CBadge>
                <CBadge v-if="certificate == 'TYPE_31'" color="secondary">3.1</CBadge>
                <CBadge v-if="certificate == 'TYPE_32'" color="secondary">3.2</CBadge>
              </span>
            </template>

            <!-- This causing error -->
            <!-- <template #h__thickness>
              <span>Thickness</span>
              <Unit v-model="length_unit" :units="length_units"></Unit>
            </template> -->

            <template #thickness="{ row }">
              <span>
                {{ ((row.thickness || 0) * length_unit.conversion).toFixed(2) }}
              </span>
            </template>

            <!-- This causing error -->
            <!-- <template #h__length>
                <span>Length</span>
                <Unit v-model="length_unit" :units="length_units"></Unit>
            </template> -->

            <template #length="{ row }">
              <span>
                {{ ((row.length || 0) * length_unit.conversion).toFixed(2) }}
              </span>
            </template>

            <!-- This causing error -->
            <!-- <template #h__width>
                <span>Width</span>
                <Unit v-model="length_unit" :units="length_units"></Unit>
            </template> -->

            <template #width="{ row }">
              <span>{{ ((row.width || 0) * length_unit.conversion).toFixed(2) }}</span>
            </template>

            <!-- This causing error -->
            <!-- <template #h__height>
                <span>Height</span>
                <Unit v-model="length_unit" :units="length_units"></Unit>
            </template> -->

            <template #height="{ row }">
              <span>
                {{ ((row.height || 0) * length_unit.conversion).toFixed(2) }}
              </span>
            </template>

            <!-- This causing error -->
            <!-- <template #h__cost>
                <span>Cost</span>
                <Unit v-model="cost_unit" :units="cost_units"></Unit>
            </template> -->

            <template #cost="{ row }">
              <span v-if="cost_unit.conversion == 0">
                {{ (row.cost || 0).toFixed(2).replace(".", ",") }}
              </span>
              <span v-if="cost_unit.conversion == 1">
                {{
                  (1e-6 * row.height * row.width * row.cost)
                    .toFixed(2)
                    .replace(".", ",")
                }}
              </span>
            </template>

            <!-- This causing error -->
            <!-- <template #h__rate>
                <span>Cost</span>
                <Unit v-model="rate_unit" :units="rate_units"></Unit>
            </template> -->

            <template #rate="{ row }">
              <span>
                {{
                  ((row.cost || 0) * rate_unit.conversion).toFixed(2).replace(".", ",")
                }}
              </span>
            </template>

            <template #resource="{ row }">
              <code>{{ row.resource }}</code>
            </template>

            <template #client_id="{ row }">
              <code>{{ row.client_id }}</code>
            </template>

            <template #access_token="{ row }">
              <code>{{ row.access_token }}</code>
            </template>

            <template #refresh_token="{ row }">
              <code>{{ row.refresh_token }}</code>
            </template>

            <template #type="{ row }">
              <CBadge v-if="row.type == 'STEEL'" color="secondary">
                {{ $t("steel") }}
              </CBadge>
              <CBadge v-if="row.type == 'STAINLESS'" color="secondary">
                {{ $t("stainless") }}
              </CBadge>
              <CBadge v-if="row.type == 'ALUMINIUM'" color="light">
                {{ $t("aluminium") }}
              </CBadge>
              <CBadge v-if="row.type == 'OTHER'" color="dark">
                {{ $t("other") }}
              </CBadge>

              <CBadge v-if="row.type == 'RECTANGULAR'" color="dark">
                {{ $t("rectangular") }}
              </CBadge>
              <CBadge v-if="row.type == 'SQUARE'" color="dark">
                {{ $t("square") }}
              </CBadge>
              <CBadge v-if="row.type == 'ROUND'" color="dark">
                {{ $t("round") }}
              </CBadge>

              <CBadge v-if="row.type == 'CUT'" color="dark">{{ $t("cut") }}</CBadge>
              <CBadge v-if="row.type == 'BEND'" color="secondary">
                {{ $t("bend") }}
              </CBadge>
            </template>

            <template #stock="{ row }">
              <span style="">{{ row.stock }}</span>
            </template>

            <template #method="{ row }">
              <CBadge v-if="row.method == 'OPTIONS'" color="secondary">
                {{ row.method }}
              </CBadge>
              <CBadge v-if="row.method == 'GET'" color="success">
                {{ row.method }}
              </CBadge>
              <CBadge v-if="row.method == 'POST'" color="primary">
                {{ row.method }}
              </CBadge>
              <CBadge v-if="row.method == 'PATCH'" color="warning">
                {{ row.method }}
              </CBadge>
              <CBadge v-if="row.method == 'DELETE'" color="danger">
                {{ row.method }}
              </CBadge>
            </template>

            <template #status="{ row }">
              <CBadge v-if="Math.trunc(row.status / 100) == 2" color="success">
                {{ row.status }}
              </CBadge>
              <CBadge v-if="Math.trunc(row.status / 100) == 3" color="warning">
                {{ row.status }}
              </CBadge>
              <CBadge v-if="Math.trunc(row.status / 100) == 4" color="warning">
                {{ row.status }}
              </CBadge>
              <CBadge v-if="Math.trunc(row.status / 100) == 5" color="danger">
                {{ row.status }}
              </CBadge>

              <CBadge v-if="row.status == 'CREATED'" color="dark">
                {{ $t("created") }}
              </CBadge>
              <CBadge v-if="row.status == 'IN_REVIEW'" color="secondary">
                {{ $t("in_review") }}
              </CBadge>
              <CBadge v-if="row.status == 'CONFIRMED'" color="warning">
                {{ $t("confirmed") }}
              </CBadge>
              <CBadge v-if="row.status == 'QUOTED'" color="warning">
                {{ $t("quoted") }}
              </CBadge>
              <CBadge v-if="row.status == 'ORDERED'" color="success">
                {{ $t("ordered") }}
              </CBadge>
              <CBadge v-if="row.status == 'PRODUCED'" color="secondary">
                {{ $t("produced") }}
              </CBadge>
              <CBadge v-if="row.status == 'COMPLETED'" color="success">
                {{ $t("completed") }}
              </CBadge>
              <CBadge v-if="row.status == 'CANCELLED'" color="danger">
                {{ $t("cancelled") }}
              </CBadge>
            </template>
            <template #code="{ row }">
              <span>{{ row.code }}</span>
            </template>

            <!-- <template #actions="data">
              <slot name="actions" :data="data">
                <span>{{ $t("no_actions") }}</span>
              </slot>
            </template> -->


            <!--
              id and actions column have the same handler
              code below combining them into a single handler
            -->
            <template
              v-for="(column, i) in ['id', 'actions']"
              :key="i"
              #[column]="data"
            >
              <div class="col-lg-12 button-box text-nowrap d-flex">
                <Popover
                  v-if="props.actionEdit"
                  :text="$t('preview')"
                >
                  <CButton
                    v-if="props.actionViewer"
                    class="btn-space btn-sm"
                    color="secondary"
                    @click.stop.prevent="
                      emit('action-clicked', { action: 'viewer', data: data.row })
                    "
                  >
                    <i class="fa fa-search" />
                  </CButton>
                </Popover>
                <Popover
                  v-if="props.actionEdit"
                  :text="`${$t('edit')} ${props.title}`"
                >
                  <CButton
                    class="btn-space btn-sm"
                    color="primary"
                    @click.stop.prevent="editRow(data)"
                  >
                    <i class="fa fa-edit" />
                  </CButton>
                </Popover>
                <Popover
                  v-if="props.actionDelete"
                  :text="`${$t('remove')} ${props.title}`"
                >
                  <CButton
                    v-if="props.actionDelete"
                    class="btn-space btn-sm text-white"
                    color="danger"
                    @click.stop.prevent="deleteRow(data.row)"
                  >
                    <i class="fa fa-trash" />
                  </CButton>
                </Popover>
              </div>
            </template>

            <!--
              Type based columns are the columns that grouped based on their types
              e.g. date__delivery_date means the column type is date and value is delivery_date
              This is very useful as we don't have to define each date columns to format them
            -->
            <template
              v-for="(column, i) in getTypeBasedColumns('date__')"
              :key="i"
              #[column]="{ row }"
            >
              <span>{{ dateFormat(row[column.replace("date__", "")]) }}</span>
              <div class="text-muted small">
                {{ daysAgo(row[column.replace("date__", "")]) }}
              </div>
              <span
                v-if="
                  column.includes('delivery_date') &&
                  row[column.replace('date__', '')] === null
                "
              >
                {{ $t("not_set") }}
              </span>
            </template>
            <template
              v-for="(column, i) in getTypeBasedColumns('boolean__')"
              :key="i"
              #[column]="{ row }"
            >
              <i
                :style="`color: ${row[column.replace('boolean__', '')] ? 'green' : 'red'}`"
                :class="`text-center w-100 fa fa-${
                  row[column.replace('boolean__', '')] ? 'check' : 'times'
                }`"
              />
            </template>

            <!--
              This is for handling slots added on component usage
            -->
            <template v-for="(_, slot) of $slots" #[slot]="scope">
              <slot :name="slot" v-bind="scope" />
            </template>
          </v-client-table>
        </CCardBody>
      </CCard>
    </CContainer>
    <FormModal
      :title="isEditing ? props.editText : props.addText"
      :show="showFormModal"
      :form="form"
      :ok-button-text="isEditing ? $t('save') : $t('add')"
      @reset="onFormReset"
      @submit="onFormSubmitted"
      @change="values => emit('formChanged', values)"
      @reload="onFormReload"
    />
  </div>
</template>

<script lang="ts" setup>
import { type UnwrapRef, type DefineComponent, onUnmounted, ref, computed, type Ref, watchEffect, watch } from "vue-demi"
import { isEqual, pick, pickBy, values } from "lodash-es"
import sweetalert from "sweetalert2"
import { useI18n } from "vue-i18n"
import type {
  OptimisticAddOptionInterface, OptimisticUpdateOptionInterface, MergerSchema
} from "@/interfaces"
import { mergerDefaultIdColumn } from "@/interfaces"
import FormModal from "@/components/modals/FormModal.vue"
import MergerModal from "@/components/modals/MergerModal.vue"
import { dateFormat, daysAgo, getFilterEmitsOptions, copyTextToClipboard } from "@/libraries/helpers"
import Popover from "@/components/Popover.vue"
import { globalStore } from "@/store"

const i18n = useI18n()

const emit = defineEmits([
  "add",
  "update",
  "formChanged",
  "rowClick",
  "reset",
  "delete",
  "action-clicked",
  "merge-done",
  "table-loaded",
])

const props = withDefaults(defineProps<Props>(), {
  title: "Title",
  subtitle: "Subtitle",
  columns: () => [],
  addText: "",
  editText: "",
  showAddButton: false,
  actionEdit: false,
  actionDelete: false,
  actionViewer: false,
  defaultSort: () => ({
    column: "created",
    ascending: false,
  }),
  mergeOptions: () => ({
    idColumn: "id",
    whitelist: [] as string[],
    schema: {} as MergerSchema,
  }),
  showMergeOptions: false,
  add: () => {},
  update: () => {},
  remove: () => {},
})

const length_unit = { name: "mm", conversion: 1 }
const length_units = [
  { name: "mm", conversion: 1 },
  { name: "cm", conversion: 1e-1 },
  { name: "m", conversion: 1e-3 },
]
const cost_unit = { name: "€ / m<sup>2</sup>", conversion: 0 }
const cost_units = [
  {"name": "€ / m<sup>2</sup>", "conversion": 0},
  {"name": "€ / pcs.", "conversion": 1}
]
const rate_unit = { name: "€ / sec", conversion: 1 }
const rate_units = [
  { name: "€ / sec", conversion: 1 },
  { name: "€ / min", conversion: 60 },
  { name: "€ / hr", conversion: 3600 },
]

const tableElement = ref<Ref>(null)

const form = ref(props.makeForm() as any)

const mergeModal = ref(false)
const isLoading = ref(false)
const showFormModal = ref(false)
const tableData = ref([])
const inputSearch = ref("")

const key = computed(() => (props.data || []).length || 0)
const isEditing = computed(() => !!form.value?.fields?.id?.defaultValue)
const options = computed(() => {
  const filterableColumns = props.tableOptions.filterable ? props.tableOptions.filterable : props.columns
  return {
    pagination: {
      chunk: 5,
      nav: "scroll",
      edge: false, 
      show: false // hide pagination because it moved into app footer
    },
    sortIcon: {
      base: "fa fa-lg",
      up: "fa-sort-asc",
      down: "fa-sort-desc",
      is: "fa-sort",
    },
    perPageValues: [1, 20, 30, 40, 50],
    perPage: 50,
    skin: "table table-hover",
    orderBy: props.defaultSort,
    page: 1,
    texts: {
      count: "",
      filter: "",
      filterPlaceholder: "",
      limit: "",
      page: "",
      noResults: i18n.t("no_results"),
      loading: i18n.t("loading"),
    },
    // commented because slots not handled if activated
    // templates:{
    //   created: function(h, row) {
    //     return moment(row.created).fromNow();
    //   },
    //   updated: function(h, row) {
    //     return moment(row.updated).fromNow();
    //   },
    //   start_time: function(h, row) {
    //     return moment.unix(row.start_time).fromNow();
    //   },
    //   expires: function(h, row) {
    //     return moment(row.expires).fromNow();
    //   },
    // },
    filterByColumn: true,
    customFilters: [
      {
        name: "all",
        callback(row: any, query: string) {
          const str = values(pick(row, filterableColumns))
            .join("#####") // ##### as separator
            .toLowerCase()
          return str.includes(query.toLowerCase())
        },
      },
    ],
    ...props.tableOptions,
  }
})

const rowClickHandler = computed(() => props.rowClick || editRow)
const addButtonClickHandler = computed(() => props.addButtonClick || onAddButtonClick)
const computedData = computed(() => {
  let filteredData = props.data
  if (props.dataFilter) filteredData = filteredData.filter(props.dataFilter)
  return filteredData
})

const setRow = async (id: string | number, rowData: any) => {
  const { whitelist, idColumn = mergerDefaultIdColumn } = props.mergeOptions
  let oldRow = props.data.find(d => id == d[idColumn])
  if (oldRow) oldRow = pick(oldRow, whitelist)
  rowData = pick(rowData, whitelist)

  if (!oldRow) return props.add(rowData, { withoutOptimistic: true })

  const hasChanged = (value, key) => oldRow[key] != value && !isEqual(oldRow[key], value)

  const changes = pickBy(rowData, hasChanged)
  if (!Object.keys(changes).length) return {}

  return props.update({ id: rowData.id, ...changes }, { withoutOptimistic: true })
}
const editRow = (d: any) => {
  form.value = props.makeForm(d.row)
  showFormModal.value = true
}
const deleteRow = (row: any) => {
  sweetalert
    .fire({
      title: i18n.t("remove"),
      text: i18n.t("delete_row_body"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: i18n.t("delete"),
      cancelButtonText: i18n.t("cancel"),
    })
    .then(result => {
      if (result.isConfirmed) {
        props.remove(row)
        emit("delete", row)
      }
    })
    .catch()
}

const onFormSubmitted = (values: any) => {
  showFormModal.value = false
  isEditing.value ? props.update(values) : props.add(values)
}
const onFormReset = () => {
  showFormModal.value = false
  form.value = props.makeForm()
}
const onFormReload = (values) => {
  form.value = props.makeForm(values)
}

const onAddButtonClick = () => {
  onFormReset()
  showFormModal.value = true
}
const getTypeBasedColumns = (prefix: string) => {
  return props.columns.filter((v: string) => v.includes(prefix))
}
const handleTableLoaded = () => {
  if (tableElement.value) {
    globalStore.changeFooter({
      totalData: (tableElement.value.allFilteredData || []).length,
      perPage: tableElement.value.options.perPage,
      currentPage: tableElement.value.$refs?.table?.page || 1,
      showPagination: true
    })
  }
}

watchEffect(() => {
  if (tableElement.value) {
    tableElement.value.setCustomFilters({ all: inputSearch.value })
    tableElement.value.$.emitsOptions = {
      ...tableElement.value.$.emitsOptions,
      ...getFilterEmitsOptions(props.tableOptions.filterable || []),
    }
  }
})
watch(
  () => globalStore.footer.pagination.currentPage,
  () => tableElement.value.setPage(globalStore.footer.pagination.currentPage)
)

onUnmounted(() => {
  globalStore.reset(["footer"])
})
</script>

<script lang="ts">
/**
 * Explanation of this code block:
 * We use this separate <script lang="ts" /> block
 * to be able to export types and constants.
 * Since we are not able to do that within the <script setup /> block.
 * Also, one important note is that this code block
 * HAS TO BE beneath the <script setup /> code block.
 * If you swap them around, then eslint will move
 * all the code from this block to the other block,
 * thereby breaking the code.
 **/

// eslint-disable-next-line import/order
import type { ArrayElement } from "@/interfaces"

interface VTableOrderBy {
  column: string
  ascending: boolean
}

interface TableCustomFilter {
  name: string
  callback: (row: any, query: string) => boolean
}

export interface VTableOptions {
  headings: Record<string, string>
  sortable?: string[]
  filterable?: string[]
  listColumns?: Record<string, Record<string, any>[]>
  filterAlgorithm?: Record<string, (row: any, query: string) => boolean>
  customSorting?: Record<string, (ascending: boolean) => (a: any, b: any) => number>
  customFilters?: TableCustomFilter[]
}

type GetApiData = () => Pick<Record<any, any>, "data" | "isLoading"> &
  Partial<Pick<Record<any, any>, "add" | "update" | "remove">>

interface Props<T extends GetApiData = GetApiData> {
  title?: string
  subtitle?: string
  columns?: string[]
  addText?: string
  editText?: string
  showAddButton?: boolean
  actionEdit?: boolean
  actionDelete?: boolean
  actionViewer?: boolean
  defaultSort?: VTableOrderBy
  rowClick?: (event: { index: number; event: PointerEvent; row: DataRow<T> }) => void

  addButtonClick?: (event: MouseEvent) => any
  mergeOptions?: {
    idColumn?: string
    whitelist: string[]
    schema: MergerSchema
    dataProcessor?: (d: any[]) => any[]
    valueProcessor?: (d: any[]) => any[]
    customValidation?: (value: any, error: any) => { errors: any; values: any }
  }
  api?: T
  makeForm: (d?: any) => object
  showMergeOptions?: boolean
  dataFilter?: (d?: any) => boolean
  tableOptions: VTableOptions
  data: any[],
  add?: (values: any, options?: OptimisticAddOptionInterface) => void,
  update?: (values: any, options?: OptimisticUpdateOptionInterface) => void,
  remove?: (values: any) => void,
}

type UnwrappedData<T extends GetApiData> = UnwrapRef<ReturnType<T>["data"]>
type DataRow<T extends GetApiData> = ArrayElement<UnwrappedData<T>>

type A<T extends GetApiData> = {
  [key in keyof DataRow<T>]: { row: DataRow<T> }
}

type B<T extends GetApiData> = {
  [key in string]: { row: DataRow<T> }
}

export type VTablesType<T extends GetApiData> = DefineComponent<Props<T>> & {
  __VLS_slots: A<T> & B<T>
}

</script>

<style lang="scss">
.wrapped-with-fsghpnsidq {
  .card-header {
    background-color: white;
  }
  .button-box {
    align-items: center;
  }
  .btn-space {
    margin: 0px 5px 3px 0px;
  }
  .statusDiv {
    display: flex;
    flex-wrap: wrap;
    label {
      padding: 0 10px 0 0px;
      min-width: 120px;
      display: flex;
      align-items: center;
      input {
        margin-right: 4px;
      }
    }
  }
  table th {
    cursor: pointer;
  }
  p.loading {
    text-align: center;
  }
  .v-tables-component {
    .table-responsive {
      overflow-y: hidden;
    }
  }
}
</style>
